/* eslint angular/no-private-call: 0 */

import addWorkDayTemplate from './../../settings/add-work-day/add-work-day.html';
import addWorkPeriodTemplate from './../../settings/add-work-period/add-work-period.html';
import editWorkDayTemplate from './../../settings/edit-work-day/edit-work-day.html';
import editWorkPeriodTemplate from './../../settings/edit-work-period/edit-work-period.html';
import showSubstitutionTemplate from './show-substitution/show-substitution.html';
import showCancelledActivityTemplate from './show-cancellation/show-cancellation.html';
import showWorkDayTemplate from './show-work-day/show-work-day.html';
import template from './working-days.html';

class WorkingDaysComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $q, $document, $timeout, $scope, $compile,
    moment,
    ClassRoomService,
    EmployeeService,
    SubstitutionService,
    uiCalendarConfig
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$q = $q;
    this.$document = $document;
    this.$timeout = $timeout;
    this.$scope = $scope;
    this.$compile = $compile;
    this.moment = moment;
    this.ClassRoomService = ClassRoomService;
    this.EmployeeService = EmployeeService;
    this.SubstitutionService = SubstitutionService;
    this.uiCalendarConfig = uiCalendarConfig;

    this.events = [];
    this.substitutions = [];
    this.cancelledActivities = [];
    this.eventSources = [];

    this.uiConfig = {
      calendar: {
        height: 600,
        lang: 'pl',
        locale: 'pl',
        minTime: '06:00:00',
        maxTime: '23:59:00',
        timeFormat: 'HH:mm',
        allDaySlot: false,
        slotLabelFormat: 'HH:mm',
        slotDuration: '00:30:00',
        defaultDate: this.moment(),
        defaultView: 'agendaWeek',
        handleWindowResize: false,
        aspectRatio: 1,
        header: {
          left: 'title',
          center: 'month agendaWeek agendaDay listWeek',
          right: 'today prev,next'
        },
        weekends: true,
        eventAfterRender: (event, element, view) => {
          let position = 'absolute';
          if (view.name === 'month') {
            position = 'static';
          }

          const $el = angular.element(element).find('.fc-content');
          let rootElement = element;
          // Set position substitution
          this.cancelledActivities = event.cancelledActivities;
          const substituteAndCancelledActivities = [...event.substituteActivities, ...this.cancelledActivities];
          if (substituteAndCancelledActivities.length > 0) {
            substituteAndCancelledActivities.map(item => {
              const isSubstitution = Boolean(item.substituteTeacherId);
              if (isSubstitution) {
                $el.append('<div id="substitution-' + item.id + '" class="substitution" style="border: 1px solid #00564e; background-color: #009688; width: 100%; font-size: 12px; overflow: hidden; text-overflow: clip; position: ' + position + ';">' + item.startTime + ' - ' + item.endTime + '<br>' + item.substituteTeacherName + '</div>');
                if (view.name === 'listWeek') {
                  this.$scope.$ctrl.showSubstitutionById = this.showSubstitutionById;
                  const newElement = this.$compile('<tr ng-click="$ctrl.showSubstitutionById(' + item.id + ');" id="substitution-' + item.id + '" class="fc-list-item scr-fc-substitution substitution"><td class="fc-list-item-time fc-widget-content">' + item.startTime + ' - ' + item.endTime + '</td><td class="fc-list-item-marker fc-widget-content"><span class="fc-event-dot" style="background-color: #009688"</span></td><td class="fc-list-item-title fc-widget-content"><a>' + item.substituteTeacherName + ' (Zastępujący)</a></td></tr>')(this.$scope);
                  rootElement.after(newElement);
                  rootElement = newElement;
                }
              } else {
                $el.append('<div id="substitution-' + item.id + '" class="substitution" style="border: 1px solid #00564e; background-color: #009688; width: 100%; font-size: 12px; overflow: hidden; text-overflow: clip; position: ' + position + ';">' + item.startTime + ' - ' + item.endTime + ' (odwołane)<br>' + event.title + '</div>');
                if (view.name === 'listWeek') {
                  this.$scope.$ctrl.showCancelledActivityById = this.showCancelledActivityById;
                  const newElement = this.$compile('<tr ng-click="$ctrl.showCancelledActivityById(' + item.id + ', \'' + event.date + '\', \'' + event.title + '\');" id="substitution-' + item.id + '" class="fc-list-item scr-fc-substitution substitution"><td class="fc-list-item-time fc-widget-content">' + item.startTime + ' - ' + item.endTime + '</td><td class="fc-list-item-marker fc-widget-content"><span class="fc-event-dot" style="background-color: #009688"</span></td><td class="fc-list-item-title fc-widget-content"><a>' + event.title + ' (odwołane)</a></td></tr>')(this.$scope);
                  rootElement.after(newElement);
                  rootElement = newElement;
                }
              }

              // Get substitution element
              const $elSubstitution = angular.element(element).find('#substitution-' + item.id);
              const eventTop = element.position().top;
              const eventBottom = eventTop + element.height();

              // Convert start and end event time to minutes
              let eventStart = event.workingHourStart.split(':');
              eventStart = (eventStart[0] * 60) + Number(eventStart[1]);
              let eventEnd = event.workingHourEnd.split(':');
              eventEnd = (eventEnd[0] * 60) + Number(eventEnd[1]);

              // Compute height (px) 60 minutes slat on calendar
              let hourHeight = 60 / ((eventEnd - eventStart) / (eventBottom - eventTop));
              hourHeight = Number(hourHeight).toPrecision(1);

              // Convert start and end substitution time to minutes
              let substitutionStart = item.startTime.split(':');
              substitutionStart = (substitutionStart[0] * 60) + Number(substitutionStart[1]);
              let substitutionEnd = item.endTime.split(':');
              substitutionEnd = (substitutionEnd[0] * 60) + Number(substitutionEnd[1]);

              // Compute substitution position top (px) and height (px)
              const top = ((substitutionStart - eventStart) / 60) * hourHeight;
              let height = ((substitutionEnd - substitutionStart) / 60) * hourHeight;

              if (view.name === 'month') {
                height = 'auto';
              }

              $elSubstitution.css({
                top: top + 'px',
                height
              });
              return item;
            });
          }
        },
        eventClick: (data, jsEvent) => {
          const substituteAndCancelledActivities = [...data.substituteActivities, ...data.cancelledActivities];
          if (jsEvent.target.className === 'substitution') {
            const id = jsEvent.target.id.split('-')[1];
            if (id) {
              const activity = substituteAndCancelledActivities.filter(item => item.id === id);
              if (activity.length > 0) {
                if (activity[0].substituteTeacherId) {
                  const substituteActivity = {
                    absentEmployee: {
                      name: data.employeeName
                    },
                    date: data.date,
                    substituteEmployee: {
                      name: activity[0].substituteTeacherName
                    },
                    startTime: activity[0].startTime,
                    endTime: activity[0].endTime
                  };
                  return this.showSubstitution(substituteActivity);
                }

                const cancelledActivity = {
                  employee: {
                    name: data.employeeName
                  },
                  date: data.date,
                  startTime: activity[0].startTime,
                  endTime: activity[0].endTime
                };
                return this.showCancelledActivity(cancelledActivity);
              }
            }

            return;
          }

          jsEvent.stopPropagation();
          if (this.me.roleName === 'MANAGER') {
            if (data.substitution && !data.workPeriodId) {
              return this.editWorkDay(data.employeeId, data.workDayId, jsEvent);
            }

            if (data.workPeriodId === null) {
              return this.editWorkDay(data.employeeId, data.id, jsEvent);
            }

            return this.chooseAction(data, jsEvent);
          }

          return this.showWorkDay(data, jsEvent);
        }
      }
    };
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }
  }

  $postLink() {
    this.loadAllEvents();
  }

  addWorkDay(ev) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'AddWorkDayController',
      template: addWorkDayTemplate,
      clickOutsideToClose: true,
      targetEvent: ev
    })
      .then(() => {
        this.loadAllEvents();
      }, () => {});
  }

  addWorkPeriod(ev) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'AddWorkPeriodController',
      template: addWorkPeriodTemplate,
      clickOutsideToClose: true,
      targetEvent: ev
    })
      .then(() => {
        this.loadAllEvents();
      }, () => {});
  }

  showSubstitution(substituteActivitie) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'ShowSubstitutionController',
      template: showSubstitutionTemplate,
      clickOutsideToClose: true,
      locals: {
        substituteActivitie
      }
    });
  }

  showCancelledActivity(cancelledActivity) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'ShowCancelledActivityController',
      template: showCancelledActivityTemplate,
      clickOutsideToClose: true,
      locals: {
        cancelledActivity
      }
    });
  }

  showCancelledActivityById(cancelledActivityId, date, teacherName) {
    const cancelledActivities = this.cancelledActivities.filter(item => parseInt(item.id, 10) === cancelledActivityId);
    if (cancelledActivities.length > 0) {
      const cancelledActivity = {
        employee: {
          name: teacherName
        },
        date,
        startTime: cancelledActivities[0].startTime,
        endTime: cancelledActivities[0].endTime
      };
      this.showCancelledActivity(cancelledActivity);
    }
  }

  showSubstitutionById(substituteId) {
    this.SubstitutionService.getActivity(substituteId)
      .then(substituteActivitie => this.showSubstitution(substituteActivitie))
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  showWorkDay(workDay, ev) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'ShowWorkDayController',
      template: showWorkDayTemplate,
      clickOutsideToClose: true,
      targetEvent: ev,
      locals: {
        workDay
      }
    });
  }

  loadAllEvents() {
    this.eventSources.splice(0, this.eventSources.length);
    return this.EmployeeService.getWorkPeriods(true).then(data => {
      this.eventSources.push(
        {
          events: data
        }
      );
    });
  }

  editWorkDay(employeeId, workDayId) {
    this.EmployeeService.getWorkDay(employeeId, workDayId)
      .then(result => {
        this.$mdDialog.show({
          bindToController: true,
          controllerAs: 'ctrl',
          controller: 'EditWorkDayController',
          ariaLabel: 'Okno dialogowe do edycji wpisu do planu pracy',
          template: editWorkDayTemplate,
          locals: {workDay: result},
          clickOutsideToClose: true
        })
          .then(() => {
            this.loadAllEvents();
          }, () => {});
      })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie udało się pobrać szczegółów wpisu.')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }

  editWorkPeriod(employeeId, workPeriodId) {
    this.EmployeeService.getWorkPeriod(employeeId, workPeriodId)
      .then(result => {
        this.$mdDialog.show({
          multiple: true,
          bindToController: true,
          controllerAs: 'ctrl',
          controller: 'EditWorkPeriodController',
          ariaLabel: 'Okno dialogowe do edycji cyklicznego wpisu do planu pracy',
          template: editWorkPeriodTemplate,
          locals: {workPeriod: result},
          clickOutsideToClose: true
        })
          .then(() => {
            this.loadAllEvents();
          }, () => {});
      });
  }

  chooseAction(data, ev) {
    const confirm = this.$mdDialog.confirm({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'ChooseActionController',
      templateUrl: 'chooseAction.html',
      clickOutsideToClose: true,
      targetEvent: ev
    });

    this.$mdDialog.show(confirm).then(isPeriod => {
      if (isPeriod) {
        this.editWorkPeriod(data.employeeId, data.workPeriodId);
      } else {
        this.editWorkDay(data.employeeId, data.id);
      }
    }, () => {});
  }
}

export const WorkingDays = {
  bindings: {
    me: '<'
  },
  template,
  controller: WorkingDaysComponent
};
